import type { AxiosInstance, AxiosRequestConfig } from "axios";

// Calls the sr-be /sr-en proxy. The browser never calls sr-en directly.

class CompanyDataAPI {
  private axios: AxiosInstance;
  private baseUrl: string;

  constructor(axios: AxiosInstance, baseUrl: string) {
    this.axios = axios;
    this.baseUrl = baseUrl;
  }

  private url(path: string) {
    return `${this.baseUrl}/${path.replace(/^\/+/, "")}`;
  }

  get = async <T = unknown>(path: string, config?: AxiosRequestConfig) => {
    const response = await this.axios.get<T>(this.url(path), config);
    return response.data;
  };

}

export default CompanyDataAPI;
